import { useContext } from "react";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from "react-router-dom";

import { Context } from "../Provider";
import DivSpinner from "../../../components/divSpinner";
import ColumnSort from "./columnSort";
import { convertDateToUKFormat } from "../../../utils";

const TableHeader = () => (
    <thead>
        <tr>
            {[
                "Tradesperson",
                "Contact Number",
                "Email",
                "Postcode",
                "Created At"
            ].map((header, index) => (
                <th
                    key={index}
                    className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7 text-center"
                >
                    <ColumnSort sortKeyName={header} />
                </th>
            ))}
            <th className="text-secondary opacity-7"></th>
        </tr>
    </thead>
);

const TableRow = ({ ftm, navigate }) => {
    const {
        ftm_profile_image_path,
        ftm_forename,
        ftm_surname,
        ftm_id,
        ftm_contact_number,
        ftm_email,
        ftm_postcode,
        ftm_createdAt
    } = ftm;

    return (
        <tr>
            <td>
                <div className="d-flex px-2 py-1">
                    <img
                        src={ftm_profile_image_path || "/assets/img/lock_user.png"}
                        className="avatar avatar-sm me-3 border-radius-lg"
                        alt="profile"
                    />
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">
                            {ftm_forename} {ftm_surname}
                        </h6>
                        <p className="text-xs text-secondary mb-0">#FTM ID {ftm_id}</p>
                    </div>
                </div>
            </td>
            <td className="text-secondary text-sm font-weight-bold">{ftm_contact_number}</td>
            <td className="text-secondary text-sm font-weight-bold">{ftm_email}</td>
            <td className="text-secondary text-sm font-weight-bold">
                {ftm_postcode || "N/A"}
            </td>
            <td className="text-secondary text-sm font-weight-bold">
                {convertDateToUKFormat(ftm_createdAt)}
            </td>
            <td className="text-center">
                <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        navigate(`/ftm/view/${ftm_id}`);
                    }}
                />
            </td>
        </tr>
    );
};

const NoDataAvailable = () => (
    <tr>
        <td colSpan="8" className="text-center">
            <span className="text-secondary text-sm font-weight-bold">
                No data available
            </span>
        </td>
    </tr>
);

const Table = () => {
    const context = useContext(Context);
    let navigate = useNavigate();
    const { state } = context;
    const { is_loading, ftms } = state;

    if (is_loading) {
        return (
            <div style={{ height: `${window.innerHeight - 387}px` }}>
                <DivSpinner />
            </div>
        );
    }

    return (
        <div className="table-responsive p-0">
            <table className="table align-items-center mb-0">
                <TableHeader />
                <tbody>
                    {ftms.length > 0 ? (
                        ftms.map((ftm, index) => (
                            <TableRow
                                key={index}
                                ftm={ftm}
                                navigate={navigate}
                            />
                        ))
                    ) : <NoDataAvailable />}
                </tbody>
            </table>
        </div>
    );
};

export default Table;